module.exports = __webpack_public_path__ + "5060ca3fefb1157469c35c2f2295e317.svg";